import { HOUR_IN_MILLISECONDS } from 'config';
import { setAnalyticsProject } from 'providers/analytics';
import { useProjectQuery } from 'providers/api';
import { useEffect } from 'react';

interface AnalyticsProjectTaggerProps {
  /** The project in the current URL (/projects/{id}/...), or null outside a project. */
  projectId: string | null;
}

// Tags every analytics event sent while a project is open with that project (the "model"), and stops
// tagging when the user leaves it. Driven by the URL so it covers every project page, not only the
// ones that load the project themselves. The id is registered straight away; the name and client
// follow once the project has loaded (normally from the cache the page itself fills).
const AnalyticsProjectTagger = ({ projectId }: AnalyticsProjectTaggerProps) => {
  const { data: project } = useProjectQuery(projectId ?? '', {
    enabled: !!projectId,
    staleTime: HOUR_IN_MILLISECONDS,
  });

  const loadedProject = project && project.entityId === projectId ? project : undefined;
  const name = loadedProject?.name;
  const client = loadedProject?.client?.name;

  useEffect(() => {
    if (!projectId) {
      setAnalyticsProject(null);
      return;
    }

    setAnalyticsProject({ id: projectId, name, client });
  }, [projectId, name, client]);

  return null;
};

export default AnalyticsProjectTagger;
